import React from "react";
import "./MarketplaceHero.css";
import mainimage from "../marketplaceassets/heroimage.png";

export default function MarketplaceHero() {
   const counters = [
    {
      value: "12+",
      text: "Years Working in Blockchain",
    },
    {
      value: "150+",
      text: "Employees",
    },
    {
      value: "500+",
      text: "Projects",
    }
  ];

  const Counter = ({ className }) => (
    <div className={`counter ${className}`}>
      {counters.map((item, index) => (
        <div className="count" key={index}>
          <h2>{item.value}</h2>
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
  return (
    <div id="marketplace-hero" className="marketmainclass">
  <div className="hero">
        <div className="left">
      <div className="content">
          <h1><strong>NFT</strong> Marketplace Development Services</h1>
        <p>
      As the leading NFT marketplace development company, BastionEx helps businesses achieve 25%+ higher user retention and up to 50% lower onboarding drop-offs. Talk to experts shaping scalable Web3 platforms.
        </p>
      </div>
       <Counter className="desktop-counter" />
      </div>
      <div className="right">
        <img src={mainimage} alt="error" />
      </div>
  </div>
  <Counter className="mobile-counter" />
    </div>
  );
}
